import StyledButton from './StyledButton';

export type { StyledButtonProps } from './StyledButton';
export default StyledButton;
